import { render, staticRenderFns } from "./DatabaseList.vue?vue&type=template&id=6854263e"
import script from "./DatabaseList.vue?vue&type=script&lang=js"
export * from "./DatabaseList.vue?vue&type=script&lang=js"
import style0 from "./DatabaseList.vue?vue&type=style&index=0&id=6854263e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports